import { render } from "./MainLogo.vue?vue&type=template&id=01270bd6&scoped=true"
const script = {}

import "./MainLogo.vue?vue&type=style&index=0&id=01270bd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01270bd6"]])

export default __exports__